import { apiClient } from './client';
import { AdminTask, AdminTaskType, AdminTaskDetail, PaginatedResponse } from '../../types';

export interface CreateAdminTaskRequest {
  type: AdminTaskType;
  detail: AdminTaskDetail;
}

export const adminTasksApi = {
  getTasks: async (params?: { pageIndex?: number; pageSize?: number; type?: string; status?: string }): Promise<PaginatedResponse<AdminTask>> => {
    return apiClient.get<PaginatedResponse<AdminTask>>('/api/v1/admin/tasks', { params });
  },

  getTaskDetail: async (id: string): Promise<{ data: AdminTask }> => {
    return apiClient.get<{ data: AdminTask }>(`/api/v1/admin/tasks/${id}`);
  },

  createTask: async (data: CreateAdminTaskRequest): Promise<{ data: AdminTask }> => {
    return apiClient.post<{ data: AdminTask }>('/api/v1/admin/tasks', data);
  },

  resumeTask: async (id: string): Promise<{ data: AdminTask }> => {
    return apiClient.post<{ data: AdminTask }>(`/api/v1/admin/tasks/${id}/resume`);
  },
};
